/**
 * System-only group
 *
 * Outlines a run of controls that only system-level credentials can see and carries the badge once,
 * in the legend, so the controls inside keep plain labels.
 */

import React from 'react';
import { I18n } from 'react-redux-i18n';
import SystemOnlyBadge, { systemOnlyBadgeKeys } from './SystemOnlyBadge';
import Styles from './SystemOnlyBadge.module.css';

interface SystemOnlyGroupProps {
  children: React.ReactNode;
  className?: string;
}

export const SystemOnlyGroup: React.FC<SystemOnlyGroupProps> = ({
  children,
  className
}) => (
  <fieldset
    className={className ? `${Styles.group} ${className}` : Styles.group}
  >
    <legend className={Styles.legend}>
      {I18n.t(systemOnlyBadgeKeys.TITLE)}
      <SystemOnlyBadge />
    </legend>
    {children}
  </fieldset>
);

export default SystemOnlyGroup;
